document.addEventListener('DOMContentLoaded', function() {
  const galleries = document.querySelectorAll('[data-product-gallery]');
  
  galleries.forEach(gallery => {
    const images = gallery.querySelectorAll('.anvibha-gallery-img');
    const dots = gallery.querySelectorAll('.anvibha-gallery-dot');
    const prevBtn = gallery.querySelector('.anvibha-gallery-prev');
    const nextBtn = gallery.querySelector('.anvibha-gallery-next');
    let currentIndex = 0;
    
    function showImage(index) {
      // Remove active class from all images and dots
      images.forEach(img => img.classList.remove('active'));
      dots.forEach(dot => dot.classList.remove('active'));
      
      // Add active class to current image and dot
      if (images[index]) {
        images[index].classList.add('active');
      }
      if (dots[index]) {
        dots[index].classList.add('active');
      }
      
      currentIndex = index;
    }
    
    // Previous button
    if (prevBtn) {
      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const newIndex = currentIndex === 0 ? images.length - 1 : currentIndex - 1;
        showImage(newIndex);
      });
    }
    
    // Next button
    if (nextBtn) {
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const newIndex = currentIndex === images.length - 1 ? 0 : currentIndex + 1;
        showImage(newIndex);
      });
    }
    
    // Dots navigation
    dots.forEach((dot, index) => {
      dot.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        showImage(index);
      });
    });
  });
  
  // Add to Cart functionality
  const addToCartButtons = document.querySelectorAll('.anvibha-add-to-cart');
  console.log('Found add to cart buttons:', addToCartButtons.length);
  
  addToCartButtons.forEach(button => {
    button.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      const variantId = button.getAttribute('data-variant-id');
      console.log('Add to cart clicked, variant ID:', variantId);
      
      if (!variantId || button.disabled) {
        console.log('Button disabled or no variant ID');
        return;
      }
      
      const originalText = button.textContent;
      button.disabled = true;
      button.textContent = 'Adding...';
      
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        });
        
        const responseData = await response.json();
        console.log('Cart add response:', responseData);
        
        if (response.ok) {
          button.textContent = 'Added! ✓';
          
          // Dispatch cart update event with quantity added (1)
          const cartUpdateEvent = new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: responseData,
              sourceId: 'anvibha-featured-products',
              data: {
                itemCount: 1,
                source: 'product-form-component',
                variantId: responseData.variant_id
              }
            }
          });
          document.dispatchEvent(cartUpdateEvent);
          
          // Reset button after 2 seconds
          setTimeout(() => {
            button.disabled = false;
            button.textContent = originalText;
          }, 2000);
        } else {
          throw new Error('Failed to add to cart');
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
        button.textContent = 'Error';
        setTimeout(() => {
          button.disabled = false;
          button.textContent = originalText;
        }, 2000);
      }
    });
  });
  
  // Quick Buy functionality
  const quickBuyButtons = document.querySelectorAll('.anvibha-quick-buy');
  console.log('Found quick buy buttons:', quickBuyButtons.length);
  
  quickBuyButtons.forEach(button => {
    button.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      const variantId = button.getAttribute('data-product-id');
      console.log('Quick buy clicked, variant ID:', variantId);
      
      if (!variantId) {
        console.error('No variant ID found on button');
        return;
      }
      
      const originalText = button.innerHTML;
      button.disabled = true;
      button.innerHTML = '<span>Processing...</span>';
      
      // Add to cart first
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        });
        
        const responseData = await response.json();
        console.log('Cart add response:', responseData);
        
        if (response.ok) {
          console.log('Item added to cart, redirecting to checkout...');
          
          // Dispatch cart update event with quantity added (1) before redirect
          const cartUpdateEvent = new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: responseData,
              sourceId: 'anvibha-featured-products-quick-buy',
              data: {
                itemCount: 1,
                source: 'product-form-component',
                variantId: responseData.variant_id
              }
            }
          });
          document.dispatchEvent(cartUpdateEvent);
          
          // Redirect to checkout
          window.location.href = '/checkout';
        } else {
          throw new Error('Failed to add to cart');
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
        button.disabled = false;
        button.innerHTML = originalText;
        alert('Failed to add item to cart. Please try again.');
      }
    });
  });
});
